// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"AdminSetPasswordModal_checkboxLabel__kxj9H","checkboxText":"AdminSetPasswordModal_checkboxText__QDYiP"};